export var TOKEN_CHANGED = "@@firekit/MESSAGING@TOKEN_CHANGED";
export var PERMISSION_CHANGED = "@@firekit/MESSAGING@PERMISSION_CHANGED";
export var MESSAGING_ERROR = "@@firekit/MESSAGING@MESSAGING_ERROR";
export var ON_MESSAGE = "@@firekit/MESSAGING@ON_MESSAGE";
export var ON_CLEAR_MESSAGE = "@@firekit/MESSAGING@ON_CLEAR_MESSAGE";


//////////////////
// WEBPACK FOOTER
// ./node_modules/firekit/es/store/messaging/types.js
// module id = 301
// module chunks = 49